import SlimSelect from 'slim-select';
import selectors from '../../scripts/constants';

export default class EVP_SlimSelect {
    constructor() {
        this.slimSelect = document.querySelectorAll(selectors.langSelect);
    }
    init() {
        this.slimSelect.forEach((elem, i) => {
            new SlimSelect({
                select: elem,
                showSearch: false,
                hideSelectedOption: true
            });

            elem.addEventListener('change', () => {
                if (elem.selectedIndex === -1) {
                    return;
                }

                const value = elem.options[elem.selectedIndex].value;
                if (value) {
                    window.location.href = value;
                }
            })
        })
    }
}
